import React from 'react';

const Footer = () => {
  return (
    <footer className="max-w-7xl mx-auto mt-16 pt-8 border-t border-slate-800 text-center">
      <p className="text-slate-500 text-sm">
        Seedling — Visualizing the compound power of financial decisions across generations
      </p>
      <p className="text-slate-600 text-sm mt-2">
        Built for first-generation wealth builders
        <span className="ml-2 text-seedling-500">💚</span>
      </p>
    </footer>
  );
};

export default Footer;
